import baseRoute from '../baseRoute';

export type * from './viewModel';
export type * from './queryParams';

type RouteDefinition = `${typeof baseRoute}/workSummary/csv${`?startDate=${string}&endDate=${string}&filterByText=${string}` | ''}`;

export const ROUTE: RouteDefinition = `${baseRoute}/workSummary/csv`;

export const URL = (startDate: string, endDate: string, filterByText: string): RouteDefinition =>
	`${baseRoute}/workSummary/csv?startDate=${startDate}&endDate=${endDate}&filterByText=${filterByText}`;
